import React, { type PropsWithChildren } from 'react';
import { StyleSheet } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useStyle } from 'react-native-style-utilities';

import { Container, theme, useContainerSpacing, useResponsive } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const MenuHeaderAlertsContainer = (props: PropsWithChildren) => {
  const { children } = props;

  const { currentBreakpoint } = useResponsive();
  const containerSpacing = useContainerSpacing();
  const { right: safeAreaRightInset, left: safeAreaLeftInset } = useSafeAreaInsets();

  // ─── Styles ────────────────────────────────────────────────────────────────

  const containerDynamicStyle = useStyle(() => {
    if (currentBreakpoint.isLG) {
      return;
    }

    return {
      paddingRight: Math.max(safeAreaRightInset, containerSpacing),
      paddingLeft: Math.max(safeAreaLeftInset, containerSpacing),
    };
  }, [currentBreakpoint.isLG, containerSpacing, safeAreaRightInset, safeAreaLeftInset]);
  const containerStyles = [styles.container, containerDynamicStyle];

  // ───────────────────────────────────────────────────────────────────────────

  return (
    <Container removeSpacing={currentBreakpoint.isLG} style={containerStyles}>
      {children}
    </Container>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    gap: theme.spacing['4'],
    alignItems: 'flex-start',
    marginBottom: theme.spacing['5'],
  },
});
